/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./resources/app.ts"
/*!**************************!*\
  !*** ./resources/app.ts ***!
  \**************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_CookieBanner_Cookiebanner__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @components/CookieBanner/Cookiebanner */ "./resources/scripts/components/CookieBanner/Cookiebanner.ts");
/* harmony import */ var _components_Geolocator_Geolocator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @components/Geolocator/Geolocator */ "./resources/scripts/components/Geolocator/Geolocator.ts");
/* harmony import */ var _scripts_components_Consent_Consent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./scripts/components/Consent/Consent */ "./resources/scripts/components/Consent/Consent.ts");
/* harmony import */ var _scripts_components_lowStock_lowStock__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./scripts/components/lowStock/lowStock */ "./resources/scripts/components/lowStock/lowStock.ts");
/* harmony import */ var _scripts_components_ShopTheLook_ShopTheLook__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./scripts/components/ShopTheLook/ShopTheLook */ "./resources/scripts/components/ShopTheLook/ShopTheLook.ts");
/* harmony import */ var _scripts_components_RemoveAll_RemoveAll__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./scripts/components/RemoveAll/RemoveAll */ "./resources/scripts/components/RemoveAll/RemoveAll.ts");
/* harmony import */ var _scripts_components_PredictiveSearch_PredictiveSearch__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./scripts/components/PredictiveSearch/PredictiveSearch */ "./resources/scripts/components/PredictiveSearch/PredictiveSearch.ts");
/* harmony import */ var _scripts_components_CustomFilters_CustomFilters__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./scripts/components/CustomFilters/CustomFilters */ "./resources/scripts/components/CustomFilters/CustomFilters.ts");
/* harmony import */ var _scripts_components_Wishlist_Wishlist__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./scripts/components/Wishlist/Wishlist */ "./resources/scripts/components/Wishlist/Wishlist.ts");
/* harmony import */ var _scripts_components_Wishlist_WishlistButton__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./scripts/components/Wishlist/WishlistButton */ "./resources/scripts/components/Wishlist/WishlistButton.ts");










var consent = new _scripts_components_Consent_Consent__WEBPACK_IMPORTED_MODULE_2__["default"]();
consent.init();
customElements.define("geolocator-component", _components_Geolocator_Geolocator__WEBPACK_IMPORTED_MODULE_1__["default"]);
customElements.define("cookie-banner", _components_CookieBanner_Cookiebanner__WEBPACK_IMPORTED_MODULE_0__["default"]);
customElements.define("low-stock", _scripts_components_lowStock_lowStock__WEBPACK_IMPORTED_MODULE_3__["default"]);
customElements.define("shop-the-look", _scripts_components_ShopTheLook_ShopTheLook__WEBPACK_IMPORTED_MODULE_4__["default"]);
customElements.define("remove-all", _scripts_components_RemoveAll_RemoveAll__WEBPACK_IMPORTED_MODULE_5__["default"]);
customElements.define("predictive-search-component", _scripts_components_PredictiveSearch_PredictiveSearch__WEBPACK_IMPORTED_MODULE_6__["default"]);
customElements.define("custom-filters", _scripts_components_CustomFilters_CustomFilters__WEBPACK_IMPORTED_MODULE_7__["default"]);
customElements.define("wishlist-button", _scripts_components_Wishlist_WishlistButton__WEBPACK_IMPORTED_MODULE_9__["default"]);
customElements.define("wishlist-component", _scripts_components_Wishlist_Wishlist__WEBPACK_IMPORTED_MODULE_8__["default"]);

/***/ },

/***/ "./resources/scripts/components/Consent/Consent.ts"
/*!*********************************************************!*\
  !*** ./resources/scripts/components/Consent/Consent.ts ***!
  \*********************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Consent)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Consent Component
//
// This class manages user consent tracking and interaction with Shopify's consent-tracking API.
// It includes methods for initializing consent features, handling consent updates, and interacting
// with Shopify's privacy settings.
//
// Key Functionalities:
// - `init()`: Loads Shopify's consent-tracking API and initializes the consent component.
// - `initConsentComponent()`: Sets up event listeners for consent actions, such as recalling consent preferences.
// - `handleConsentUpdate(state: string)`: Updates consent settings based on the user's current preferences.
//   - Parameters:
//     - `state`: A string representing the consent state ("granted", "denied", etc.).
// - `checkConsentBannerInteraction()`: Verifies if the user has interacted with the consent banner.
// - `gtag(...args)`: Pushes consent-related events to the Google Tag Manager data layer.
// - `recallConsent()`: Displays the privacy banner to allow users to update their consent preferences.
// - `logConsent(consentSettings: object)`: Logs the user's consent preferences to a database or analytics tool.
//
// Dependencies:
// - `window.dataLayer`: Required for Google Consent Mode V2 integration.
// - Shopify Customer Privacy Banner: Must be enabled in the Shopify admin panel.
//
// Error Handling:
// - Errors in loading Shopify features (e.g., API initialization failures) are logged to the console without blocking the process.
//
// Extensibility:
// - Support additional consent categories or analytics tools by extending `handleConsentUpdate` and other methods.
// - Update `logConsent` to integrate with custom databases or third-party analytics platforms as needed.
//
// Notes:
// - Local storage is used to persist consent settings across sessions.
// Usage Example:
// 1. Import the `Consent` class and initialize it in your application:
// ---- import Consent from './scripts/components/Consent/Consent';
// ---- const consent = new Consent();
// ---- consent.init();
//
// 2. To enable the recall consent feature, add an element with the ID "recall-consent" to the DOM:
// ---- <a href="#" id="recall-consent"></a>
//
// 3. Add Locales: en: "change_cookie_settings": "Change your cookie settings", da: "change_cookie_settings": "Tilpas dine cookie-indstillinger",
var Consent = /*#__PURE__*/function () {
  // declare dataLayer
  function Consent() {
    _classCallCheck(this, Consent);
    this.init = this.init.bind(this);
    this.handleConsentUpdate = this.handleConsentUpdate.bind(this);
    this.checkConsentBannerInteraction = this.checkConsentBannerInteraction.bind(this);
    this.gtag = this.gtag.bind(this);
    this.recallConsent = this.recallConsent.bind(this);
  }
  return _createClass(Consent, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this = this;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              window.Shopify.loadFeatures([{
                name: "consent-tracking-api",
                version: "0.1"
              }], function (error) {
                if (error) {
                  // eslint-disable-next-line no-console
                  console.error("Error loading features: ", error);
                  return;
                }
                // eslint-disable-next-line no-console
                console.log("Consent tracking API loaded");
                _this.initConsentComponent();
              });
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "initConsentComponent",
    value: function () {
      var _initConsentComponent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this2 = this;
        var recallConsentElement;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              window.dataLayer = window.dataLayer || [];
              document.addEventListener("visitorConsentCollected", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      _this2.handleConsentUpdate("update");
                    case 1:
                      return _context2.a(2);
                  }
                }, _callee2);
              })));
              recallConsentElement = document.getElementById("recall-consent");
              if (recallConsentElement) {
                recallConsentElement.addEventListener("click", function (event) {
                  event.preventDefault();
                  _this2.recallConsent();
                });
              }
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      function initConsentComponent() {
        return _initConsentComponent.apply(this, arguments);
      }
      return initConsentComponent;
    }()
  }, {
    key: "handleConsentUpdate",
    value: function () {
      var _handleConsentUpdate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(state) {
        var visitorConsent, consent;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return window.Shopify.customerPrivacy.currentVisitorConsent();
            case 1:
              visitorConsent = _context4.v;
              consent = {
                functionality_storage: "granted",
                analytics_storage: visitorConsent.analytics === "yes" ? "granted" : "denied",
                personalization_storage: visitorConsent.analytics === "yes" ? "granted" : "denied",
                ad_storage: visitorConsent.marketing === "yes" ? "granted" : "denied",
                ad_user_data: visitorConsent.marketing === "yes" ? "granted" : "denied",
                ad_personalization: visitorConsent.marketing === "yes" ? "granted" : "denied",
                wait_for_update: 3000
              };
              this.gtag("consent", state, consent);
              // set local Storage for consent settings for further use on other pages or after page
              localStorage.setItem("consentSettings", JSON.stringify(consent));
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function handleConsentUpdate(_x) {
        return _handleConsentUpdate.apply(this, arguments);
      }
      return handleConsentUpdate;
    }() /* eslint-disable */
  }, {
    key: "checkConsentBannerInteraction",
    value: (function () {
      var _checkConsentBannerInteraction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var visitorConsent;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return window.Shopify.customerPrivacy.currentVisitorConsent();
            case 1:
              visitorConsent = _context5.v;
              if (!(visitorConsent.preferences === "" && visitorConsent.analytics === "" && visitorConsent.marketing === "")) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2, false);
            case 2:
              return _context5.a(2, true);
          }
        }, _callee5);
      }));
      function checkConsentBannerInteraction() {
        return _checkConsentBannerInteraction.apply(this, arguments);
      }
      return checkConsentBannerInteraction;
    }()
    /* eslint-disable */
    /* eslint-disable */
    )
  }, {
    key: "gtag",
    value: function gtag() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      window.dataLayer.push(arguments);
    }
    /* eslint-enable */
    /* eslint-disable */
  }, {
    key: "recallConsent",
    value: (function () {
      var _recallConsent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              window.privacyBanner.showPreferences();
            case 1:
              return _context6.a(2);
          }
        }, _callee6);
      }));
      function recallConsent() {
        return _recallConsent.apply(this, arguments);
      }
      return recallConsent;
    }())
  }]);
}();


/***/ },

/***/ "./resources/scripts/components/CookieBanner/Cookiebanner.ts"
/*!*******************************************************************!*\
  !*** ./resources/scripts/components/CookieBanner/Cookiebanner.ts ***!
  \*******************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CookieBanner)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CookieBanner = /*#__PURE__*/function (_HTMLElement) {
  function CookieBanner() {
    var _this;
    _classCallCheck(this, CookieBanner);
    _this = _callSuper(this, CookieBanner);
    _defineProperty(_this, "panelConsent", null);
    _defineProperty(_this, "panelDetails", null);
    _defineProperty(_this, "tabConsent", null);
    _defineProperty(_this, "tabDetails", null);
    _defineProperty(_this, "consentApiReady", false);
    _this.showConsentTab = _this.showConsentTab.bind(_this);
    _this.showDetailsTab = _this.showDetailsTab.bind(_this);
    _this.initSyncedCheckboxes = _this.initSyncedCheckboxes.bind(_this);
    _this.initConsentApis = _this.initConsentApis.bind(_this);
    _this.bindActionButtons = _this.bindActionButtons.bind(_this);
    _this.handleAllowAll = _this.handleAllowAll.bind(_this);
    _this.handleAllowSelected = _this.handleAllowSelected.bind(_this);
    _this.handleReject = _this.handleReject.bind(_this);
    _this.applyConsent = _this.applyConsent.bind(_this);
    _this.getSelections = _this.getSelections.bind(_this);
    _this.showBanner = _this.showBanner.bind(_this);
    _this.hideBanner = _this.hideBanner.bind(_this);
    _this.ensureGtag = _this.ensureGtag.bind(_this);
    _this.getOverlay = _this.getOverlay.bind(_this);
    _this.restoreSelections = _this.restoreSelections.bind(_this);
    return _this;
  }
  _inherits(CookieBanner, _HTMLElement);
  return _createClass(CookieBanner, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this2 = this;
        var recall, showBanner;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.tabConsent = this.querySelector("#tab-consent");
              this.tabDetails = this.querySelector("#tab-details");
              this.panelConsent = this.querySelector("#panel-consent");
              this.panelDetails = this.querySelector("#panel-details");
              if (this.tabConsent) this.tabConsent.addEventListener("click", this.showConsentTab);
              if (this.tabDetails) this.tabDetails.addEventListener("click", this.showDetailsTab);
              _context.n = 1;
              return this.initConsentApis();
            case 1:
              this.showConsentTab();
              this.initSyncedCheckboxes();
              this.seedSelectionsFromHtmlIfFirstVisit();
              _context.n = 2;
              return this.restoreSelections();
            case 2:
              this.bindActionButtons();
              recall = document.getElementById("recall-consent-banner");
              if (recall) {
                recall.addEventListener("click", function (event) {
                  event.preventDefault();
                  _this2.showBanner();
                });
              }
              _context.n = 3;
              return this.checkConsentBannerInteraction();
            case 3:
              showBanner = _context.v;
              if (showBanner) this.showBanner();
            case 4:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }() // Show banner if visitor hasn't made a choice yet
  }, {
    key: "checkConsentBannerInteraction",
    value: function () {
      var _checkConsentBannerInteraction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _window$Shopify;
        var _visitorConsent$prefe, _visitorConsent$analy, _visitorConsent$marke, visitorConsent, empty, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!(localStorage.getItem("consentGiven") === "true")) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, false);
            case 1:
              if (!(!this.consentApiReady || !((_window$Shopify = window.Shopify) !== null && _window$Shopify !== void 0 && (_window$Shopify = _window$Shopify.customerPrivacy) !== null && _window$Shopify !== void 0 && _window$Shopify.currentVisitorConsent))) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2, true);
            case 2:
              _context2.p = 2;
              _context2.n = 3;
              return window.Shopify.customerPrivacy.currentVisitorConsent();
            case 3:
              visitorConsent = _context2.v;
              empty = ((_visitorConsent$prefe = visitorConsent.preferences) !== null && _visitorConsent$prefe !== void 0 ? _visitorConsent$prefe : "") === "" && ((_visitorConsent$analy = visitorConsent.analytics) !== null && _visitorConsent$analy !== void 0 ? _visitorConsent$analy : "") === "" && ((_visitorConsent$marke = visitorConsent.marketing) !== null && _visitorConsent$marke !== void 0 ? _visitorConsent$marke : "") === "";
              return _context2.a(2, empty);
            case 4:
              _context2.p = 4;
              _t = _context2.v;
              return _context2.a(2, true);
          }
        }, _callee2, this, [[2, 4]]);
      }));
      function checkConsentBannerInteraction() {
        return _checkConsentBannerInteraction.apply(this, arguments);
      }
      return checkConsentBannerInteraction;
    }()
  }, {
    key: "showConsentTab",
    value: function showConsentTab() {
      if (this.panelConsent && this.panelDetails && this.tabConsent && this.tabDetails) {
        this.panelConsent.classList.remove("tw:hidden!");
        this.panelConsent.classList.add("active");
        this.panelDetails.classList.add("tw:hidden!");
        this.panelDetails.classList.remove("active");
        this.tabConsent.classList.add("active");
        this.tabDetails.classList.remove("active");
      }
    }
  }, {
    key: "showDetailsTab",
    value: function showDetailsTab() {
      if (this.panelConsent && this.panelDetails && this.tabConsent && this.tabDetails) {
        this.panelConsent.classList.add("tw:hidden!");
        this.panelConsent.classList.remove("active");
        this.panelDetails.classList.remove("tw:hidden!");
        this.panelDetails.classList.add("active");
        this.tabConsent.classList.remove("active");
        this.tabDetails.classList.add("active");
      }
    }
  }, {
    key: "initSyncedCheckboxes",
    value: function initSyncedCheckboxes() {
      var all = Array.from(this.querySelectorAll("input.ed-checkbox[data-consent]"));
      var onChange = function onChange(event) {
        var target = event.currentTarget;
        var key = target.dataset.consent;
        if (!key) return;
        var checked = target.checked;
        all.forEach(function (other) {
          if (other === target) return;
          if (other.dataset.consent !== key) return;
          if (!other.disabled) other.checked = checked;
        });
      };
      all.forEach(function (checkbox) {
        return checkbox.addEventListener("change", onChange);
      });
      var byKey = new Map();
      all.forEach(function (checkbox) {
        var key = checkbox.dataset.consent;
        if (!byKey.has(key)) byKey.set(key, []);
        byKey.get(key).push(checkbox);
      });
      Array.from(byKey.values()).forEach(function (group) {
        var source = group[0];
        group.slice(1).forEach(function (checkbox) {
          if (!checkbox.disabled) checkbox.checked = source.checked;
        });
      });
    }
  }, {
    key: "initConsentApis",
    value: function () {
      var _initConsentApis = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _window$gtag,
          _window,
          _window$gtag2,
          _window2,
          _window$gtag3,
          _window3,
          _window$Shopify2,
          _this3 = this;
        var localStorageCookieSelections, selections, defaultConsent;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              this.ensureGtag();
              localStorageCookieSelections = localStorage.getItem("cookieSelections");
              selections = localStorageCookieSelections ? function () {
                try {
                  return JSON.parse(localStorageCookieSelections);
                } catch (_unused2) {
                  return {
                    personalization: false,
                    marketing: false,
                    analytics: false
                  };
                }
              }() : {
                personalization: false,
                marketing: false,
                analytics: false
              };
              defaultConsent = {
                functionality_storage: "granted",
                analytics_storage: selections.analytics ? "granted" : "denied",
                personalization_storage: selections.personalization ? "granted" : "denied",
                ad_personalization: selections.personalization ? "granted" : "denied",
                ad_storage: selections.marketing ? "granted" : "denied",
                ad_user_data: selections.marketing ? "granted" : "denied",
                wait_for_update: 3000
              };
              (_window$gtag = (_window = window).gtag) === null || _window$gtag === void 0 || _window$gtag.call(_window, "consent", "default", defaultConsent);
              (_window$gtag2 = (_window2 = window).gtag) === null || _window$gtag2 === void 0 || _window$gtag2.call(_window2, "set", "ads_data_redaction", false);
              (_window$gtag3 = (_window3 = window).gtag) === null || _window$gtag3 === void 0 || _window$gtag3.call(_window3, "set", "url_passthrough", true);
              if ((_window$Shopify2 = window.Shopify) !== null && _window$Shopify2 !== void 0 && _window$Shopify2.loadFeatures) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              _context4.n = 2;
              return new Promise(function (resolve) {
                try {
                  window.Shopify.loadFeatures([{
                    name: "consent-tracking-api",
                    version: "0.1"
                  }], function (error) {
                    if (error) {
                      console.error("Error loading Shopify consent-tracking-api:", error);
                      resolve();
                      return;
                    }
                    _this3.consentApiReady = true;
                    resolve();
                    document.addEventListener("visitorConsentCollected", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
                      var _window$Shopify3, _window$Shopify3$curr, v, _t2;
                      return _regenerator().w(function (_context3) {
                        while (1) switch (_context3.p = _context3.n) {
                          case 0:
                            _context3.p = 0;
                            _context3.n = 1;
                            return (_window$Shopify3 = window.Shopify) === null || _window$Shopify3 === void 0 || (_window$Shopify3 = _window$Shopify3.customerPrivacy) === null || _window$Shopify3 === void 0 || (_window$Shopify3$curr = _window$Shopify3.currentVisitorConsent) === null || _window$Shopify3$curr === void 0 ? void 0 : _window$Shopify3$curr.call(_window$Shopify3);
                          case 1:
                            v = _context3.v;
                            if (v) {
                              _context3.n = 2;
                              break;
                            }
                            return _context3.a(2);
                          case 2:
                            _this3.setGroup("personalization", v.preferences === "yes");
                            _this3.setGroup("marketing", v.marketing === "yes");
                            _this3.setGroup("analytics", v.analytics === "yes");
                            _this3.saveSelections();
                            _context3.n = 4;
                            break;
                          case 3:
                            _context3.p = 3;
                            _t2 = _context3.v;
                            console.error("visitorConsentCollected handler error:", _t2);
                          case 4:
                            return _context3.a(2);
                        }
                      }, _callee3, null, [[0, 3]]);
                    })));
                  });
                } catch (e) {
                  console.error("loadFeatures threw:", e);
                  resolve();
                }
              });
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function initConsentApis() {
        return _initConsentApis.apply(this, arguments);
      }
      return initConsentApis;
    }() // eslint-disable-next-line class-methods-use-this
  }, {
    key: "ensureGtag",
    value: function ensureGtag() {
      window.dataLayer = window.dataLayer || [];
      if (!window.gtag) {
        window.gtag = function gtagShim() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          window.dataLayer.push(args);
        };
      }
    }
  }, {
    key: "bindActionButtons",
    value: function bindActionButtons() {
      var allowAllBtn = this.querySelector(".allow-all-btn");
      var allowSelectedBtn = this.querySelector(".allow-selected-btn");
      var rejectBtn = this.querySelector('[data-action="reject"]');
      if (allowAllBtn) allowAllBtn.addEventListener("click", this.handleAllowAll);
      if (allowSelectedBtn) allowSelectedBtn.addEventListener("click", this.handleAllowSelected);
      if (rejectBtn) rejectBtn.addEventListener("click", this.handleReject);
    }
  }, {
    key: "handleAllowAll",
    value: function handleAllowAll() {
      var shopify = {
        preferences: "yes",
        marketing: "yes",
        analytics: "yes"
      };
      var allCheckboxes = this.querySelectorAll("input.ed-checkbox[data-consent]");
      allCheckboxes.forEach(function (checkbox) {
        if (!checkbox.disabled) checkbox.checked = true;
      });
      this.applyConsent(shopify, true);
    }
  }, {
    key: "handleAllowSelected",
    value: function handleAllowSelected() {
      var _this$getSelections = this.getSelections(),
        personalization = _this$getSelections.personalization,
        marketing = _this$getSelections.marketing,
        analytics = _this$getSelections.analytics;
      var shopify = {
        preferences: personalization ? "yes" : "no",
        marketing: marketing ? "yes" : "no",
        analytics: analytics ? "yes" : "no"
      };
      this.applyConsent(shopify, true);
    }
  }, {
    key: "handleReject",
    value: function handleReject() {
      var shopify = {
        preferences: "no",
        marketing: "no",
        analytics: "no"
      };
      this.applyConsent(shopify, true);
    }
  }, {
    key: "seedSelectionsFromHtmlIfFirstVisit",
    value: function seedSelectionsFromHtmlIfFirstVisit() {
      var _this$querySelector, _this$querySelector2, _this$querySelector3;
      if (localStorage.getItem("cookieSelections")) return;
      var selections = {
        personalization: !!((_this$querySelector = this.querySelector('input.ed-checkbox[data-consent="personalization"]')) !== null && _this$querySelector !== void 0 && _this$querySelector.checked),
        marketing: !!((_this$querySelector2 = this.querySelector('input.ed-checkbox[data-consent="marketing"]')) !== null && _this$querySelector2 !== void 0 && _this$querySelector2.checked),
        analytics: !!((_this$querySelector3 = this.querySelector('input.ed-checkbox[data-consent="analytics"]')) !== null && _this$querySelector3 !== void 0 && _this$querySelector3.checked)
      };
      localStorage.setItem("cookieSelections", JSON.stringify(selections));
    }
  }, {
    key: "setGroup",
    value: function setGroup(key, checked) {
      var boxes = this.querySelectorAll("input.ed-checkbox[data-consent=\"".concat(key, "\"]"));
      boxes.forEach(function (cb) {
        if (!cb.disabled) cb.checked = checked;
      });
    }
  }, {
    key: "restoreSelections",
    value: function () {
      var _restoreSelections = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var raw, selections;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              raw = localStorage.getItem("cookieSelections");
              if (raw) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              try {
                selections = JSON.parse(raw);
                this.setGroup("personalization", selections.personalization);
                this.setGroup("marketing", selections.marketing);
                this.setGroup("analytics", selections.analytics);
              } catch (event) {
                console.warn("Invalid cookieSelections in localStorage; leaving HTML defaults.", event);
              }
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function restoreSelections() {
        return _restoreSelections.apply(this, arguments);
      }
      return restoreSelections;
    }()
  }, {
    key: "saveSelections",
    value: function saveSelections() {
      var selections = this.getSelections();
      localStorage.setItem("cookieSelections", JSON.stringify(selections));
    }
  }, {
    key: "getSelections",
    value: function getSelections() {
      var _this4 = this;
      var isConsentChecked = function isConsentChecked(consentType) {
        var _this4$querySelector;
        return !!((_this4$querySelector = _this4.querySelector("input.ed-checkbox[data-consent=\"".concat(consentType, "\"]"))) !== null && _this4$querySelector !== void 0 && _this4$querySelector.checked);
      };
      return {
        personalization: isConsentChecked("personalization"),
        marketing: isConsentChecked("marketing"),
        analytics: isConsentChecked("analytics")
      };
    }
  }, {
    key: "applyConsent",
    value: function () {
      var _applyConsent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(shopify, hide) {
        var _window$gtag4, _window4, _window$Shopify4, _window$Shopify4$setT;
        var google;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              google = {
                functionality_storage: "granted",
                analytics_storage: shopify.analytics === "yes" ? "granted" : "denied",
                personalization_storage: shopify.preferences === "yes" ? "granted" : "denied",
                ad_personalization: shopify.preferences === "yes" ? "granted" : "denied",
                ad_storage: shopify.marketing === "yes" ? "granted" : "denied",
                ad_user_data: shopify.marketing === "yes" ? "granted" : "denied",
                wait_for_update: 3000
              };
              (_window$gtag4 = (_window4 = window).gtag) === null || _window$gtag4 === void 0 || _window$gtag4.call(_window4, "consent", "update", google);
              this.saveSelections();
              localStorage.setItem("consentGiven", "true");
              (_window$Shopify4 = window.Shopify) === null || _window$Shopify4 === void 0 || (_window$Shopify4 = _window$Shopify4.customerPrivacy) === null || _window$Shopify4 === void 0 || (_window$Shopify4$setT = _window$Shopify4.setTrackingConsent) === null || _window$Shopify4$setT === void 0 || _window$Shopify4$setT.call(_window$Shopify4, {
                analytics: shopify.analytics === "yes",
                marketing: shopify.marketing === "yes",
                preferences: shopify.preferences === "yes"
              });
              if (hide) this.hideBanner();
            case 1:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function applyConsent(_x, _x2) {
        return _applyConsent.apply(this, arguments);
      }
      return applyConsent;
    }()
  }, {
    key: "getOverlay",
    value: function getOverlay() {
      return this.querySelector("[data-cookie-overlay]") || this;
    }
  }, {
    key: "showBanner",
    value: function showBanner() {
      var element = this.getOverlay();
      element.removeAttribute("hidden");
      element.classList.remove("tw:hidden!");
    }
  }, {
    key: "hideBanner",
    value: function hideBanner() {
      var element = this.getOverlay();
      element.classList.add("tw:hidden!");
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ },

/***/ "./resources/scripts/components/CustomFilters/CustomFilters.ts"
/*!*********************************************************************!*\
  !*** ./resources/scripts/components/CustomFilters/CustomFilters.ts ***!
  \*********************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CustomFilters)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CustomFilters = /*#__PURE__*/function (_HTMLElement) {
  function CustomFilters() {
    var _this;
    _classCallCheck(this, CustomFilters);
    _this = _callSuper(this, CustomFilters);
    _defineProperty(_this, "customFilterOptions", void 0);
    _defineProperty(_this, "customPriceFilterInputs", void 0);
    _defineProperty(_this, "collectionurl", void 0);
    _defineProperty(_this, "params", void 0);
    _defineProperty(_this, "applyPriceFilterButton", void 0);
    _defineProperty(_this, "pendingFiltersByCategory", new Map());
    // Range slider elements
    _defineProperty(_this, "minRangeInput", void 0);
    _defineProperty(_this, "maxRangeInput", void 0);
    _defineProperty(_this, "minThumb", void 0);
    _defineProperty(_this, "maxThumb", void 0);
    _defineProperty(_this, "progressBar", void 0);
    _defineProperty(_this, "minPriceInput", void 0);
    _defineProperty(_this, "maxPriceInput", void 0);
    _this.initData = _this.initData.bind(_this);
    _this.updateRangeSlider = _this.updateRangeSlider.bind(_this);
    _this.handleRangeInput = _this.handleRangeInput.bind(_this);
    _this.handlePriceInput = _this.handlePriceInput.bind(_this);
    return _this;
  }
  _inherits(CustomFilters, _HTMLElement);
  return _createClass(CustomFilters, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initData();
      this.initRangeSlider();
      this.addEventlisteners();
      this.readPriceFromURL();
      this.initializePendingFilters();
    }
  }, {
    key: "initData",
    value: function initData() {
      this.customFilterOptions = Array.from(this.querySelectorAll(".custom-filter-option"));
      this.customPriceFilterInputs = Array.from(this.querySelectorAll(".custom-price-filter"));
      this.applyPriceFilterButton = this.querySelector("#apply-price-filter");
      this.collectionurl = this.dataset.collectionurl;
      // Range slider elements
      this.minRangeInput = this.querySelector(".min-range-input");
      this.maxRangeInput = this.querySelector(".max-range-input");
      this.minThumb = this.querySelector(".min-thumb");
      this.maxThumb = this.querySelector(".max-thumb");
      this.progressBar = this.querySelector(".price-range-progress");
      this.minPriceInput = this.querySelector(".min-price-input");
      this.maxPriceInput = this.querySelector(".max-price-input");
    }
  }, {
    key: "initRangeSlider",
    value: function initRangeSlider() {
      this.updateRangeSlider();
    }
  }, {
    key: "readPriceFromURL",
    value: function readPriceFromURL() {
      var url = new URL(window.location.href);
      var params = new URLSearchParams(url.search);
      var minPrice = params.get("filter.v.price.gte");
      var maxPrice = params.get("filter.v.price.lte");
      if (minPrice && maxPrice) {
        // Update number inputs
        this.minPriceInput.value = minPrice;
        this.maxPriceInput.value = maxPrice;
        // Update range inputs
        this.minRangeInput.value = minPrice;
        this.maxRangeInput.value = maxPrice;
        // Update slider UI
        this.updateRangeSlider();
      }
    }
  }, {
    key: "updateRangeSlider",
    value: function updateRangeSlider() {
      var minVal = parseInt(this.minRangeInput.value, 10);
      var maxVal = parseInt(this.maxRangeInput.value, 10);
      var min = parseInt(this.minRangeInput.min, 10);
      var max = parseInt(this.minRangeInput.max, 10);
      // Calculate percentages for positioning
      var minPercent = (minVal - min) / (max - min) * 100;
      var maxPercent = (maxVal - min) / (max - min) * 100;
      // Update thumb positions
      this.minThumb.style.left = "".concat(minPercent, "%");
      this.maxThumb.style.left = "".concat(maxPercent, "%");
      // Update progress bar
      this.progressBar.style.left = "".concat(minPercent, "%");
      this.progressBar.style.right = "".concat(100 - maxPercent, "%");
      // Update number inputs to match range inputs
      this.minPriceInput.value = minVal.toString();
      this.maxPriceInput.value = maxVal.toString();
    }
  }, {
    key: "handleRangeInput",
    value: function handleRangeInput(event) {
      var target = event.target;
      var isMin = target.dataset.type === "min";
      var minVal = parseInt(this.minRangeInput.value, 10);
      var maxVal = parseInt(this.maxRangeInput.value, 10);
      // Prevent crossing of min and max
      if (isMin) {
        minVal = Math.min(minVal, maxVal - 1);
        this.minRangeInput.value = minVal.toString();
      } else {
        maxVal = Math.max(maxVal, minVal + 1);
        this.maxRangeInput.value = maxVal.toString();
      }
      this.updateRangeSlider();
    }
  }, {
    key: "handlePriceInput",
    value: function handlePriceInput(event) {
      var target = event.target;
      var isMin = target.classList.contains("min-price-input");
      var minVal = parseInt(this.minPriceInput.value, 10) || 0;
      var maxVal = parseInt(this.maxPriceInput.value, 10) || parseInt(this.maxRangeInput.max, 10);
      var minLimit = parseInt(this.minRangeInput.min, 10);
      var maxLimit = parseInt(this.minRangeInput.max, 10);
      // Clamp values to min/max limits
      minVal = Math.max(minLimit, Math.min(maxLimit, minVal));
      maxVal = Math.max(minLimit, Math.min(maxLimit, maxVal));
      // Prevent crossing
      if (isMin) {
        minVal = Math.min(minVal, maxVal - 1);
      } else {
        maxVal = Math.max(maxVal, minVal + 1);
      }
      // Update both number and range inputs
      this.minPriceInput.value = minVal.toString();
      this.maxPriceInput.value = maxVal.toString();
      this.minRangeInput.value = minVal.toString();
      this.maxRangeInput.value = maxVal.toString();
      this.updateRangeSlider();
    }
  }, {
    key: "addEventlisteners",
    value: function addEventlisteners() {
      var _this2 = this;
      this.customFilterOptions.forEach(function (filterOption) {
        filterOption.addEventListener("change", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                _context.n = 1;
                return _this2.toggleFilter(filterOption);
              case 1:
                return _context.a(2);
            }
          }, _callee);
        })));
      });
      this.applyPriceFilterButton.addEventListener("click", /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(event) {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                event.preventDefault();
                _this2.applyPriceFilter();
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
      // Add event listeners for category-specific apply buttons
      this.addCategoryApplyButtonListeners();
      // Range slider events
      this.minRangeInput.addEventListener("input", this.handleRangeInput);
      this.maxRangeInput.addEventListener("input", this.handleRangeInput);
      // Number input events
      this.minPriceInput.addEventListener("input", this.handlePriceInput);
      this.maxPriceInput.addEventListener("input", this.handlePriceInput);
      // Thumb drag events
      this.addThumbDragEvents(this.minThumb, this.minRangeInput);
      this.addThumbDragEvents(this.maxThumb, this.maxRangeInput);
    }
  }, {
    key: "addThumbDragEvents",
    value: function addThumbDragEvents(thumb, rangeInput) {
      var _this3 = this;
      var isDragging = false;
      var onDrag = function onDrag(e) {
        if (!isDragging) return;
        var sliderRect = thumb.closest(".price-range-slider-container").getBoundingClientRect();
        var clientX = e instanceof MouseEvent ? e.clientX : e.touches[0].clientX;
        var percent = Math.max(0, Math.min(1, (clientX - sliderRect.left) / sliderRect.width));
        var min = parseInt(rangeInput.min, 10);
        var max = parseInt(rangeInput.max, 10);
        var value = Math.round(min + percent * (max - min));
        rangeInput.value = value.toString();
        _this3.handleRangeInput({
          target: rangeInput
        });
      };
      var _stopDrag = function stopDrag() {
        isDragging = false;
        document.removeEventListener("mousemove", onDrag);
        document.removeEventListener("touchmove", onDrag);
        document.removeEventListener("mouseup", _stopDrag);
        document.removeEventListener("touchend", _stopDrag);
      };
      var startDrag = function startDrag(e) {
        isDragging = true;
        document.addEventListener("mousemove", onDrag);
        document.addEventListener("touchmove", onDrag);
        document.addEventListener("mouseup", _stopDrag);
        document.addEventListener("touchend", _stopDrag);
        e.preventDefault();
      };
      thumb.addEventListener("mousedown", startDrag);
      thumb.addEventListener("touchstart", startDrag);
    }
  }, {
    key: "applyPriceFilter",
    value: function applyPriceFilter() {
      var minValue = this.minPriceInput.value;
      var maxValue = this.maxPriceInput.value;
      // Update the URL parameters
      var url = new URL(window.location.href);
      var params = new URLSearchParams(url.search);
      params.set("filter.v.price.gte", minValue);
      params.set("filter.v.price.lte", maxValue);
      url.search = params.toString();
      this.params = params.toString();
      window.history.pushState({}, "", url.toString());
      this.reloadCollectionPage();
    }
  }, {
    key: "toggleFilter",
    value: function () {
      var _toggleFilter = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(checkbox) {
        var name, value, categoryId, categoryFilters, url, params, currentAppliedValues, pendingValues, index, hasChanges;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              name = checkbox.name, value = checkbox.value;
              categoryId = CustomFilters.getCategoryIdFromCheckbox(checkbox); // Update visual state for color swatches
              CustomFilters.updateColorSwatchVisualState(checkbox);
              // Store pending filter changes by category
              if (!this.pendingFiltersByCategory.has(categoryId)) {
                this.pendingFiltersByCategory.set(categoryId, new Map());
              }
              categoryFilters = this.pendingFiltersByCategory.get(categoryId); // Get current URL state to track what's actually applied
              url = new URL(window.location.href);
              params = new URLSearchParams(url.search);
              currentAppliedValues = params.getAll(name); // Initialize pending values with current applied state if not tracking yet
              if (!categoryFilters.has(name)) {
                categoryFilters.set(name, _toConsumableArray(currentAppliedValues));
              }
              pendingValues = categoryFilters.get(name);
              if (checkbox.checked) {
                // User wants this value selected
                if (!pendingValues.includes(value)) {
                  pendingValues.push(value);
                }
              } else {
                // User wants this value deselected
                index = pendingValues.indexOf(value);
                if (index > -1) {
                  pendingValues.splice(index, 1);
                }
              }
              // Check if there are actual changes from the applied state
              hasChanges = !CustomFilters.arraysEqual(pendingValues.sort(), currentAppliedValues.sort());
              if (!hasChanges) {
                // No changes from current state, remove from tracking
                categoryFilters["delete"](name);
              }
              // Clean up empty category
              if (categoryFilters.size === 0) {
                this.pendingFiltersByCategory["delete"](categoryId);
              }
              this.updateCategoryApplyButtonState(categoryId);
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function toggleFilter(_x2) {
        return _toggleFilter.apply(this, arguments);
      }
      return toggleFilter;
    }()
  }, {
    key: "reloadCollectionPage",
    value: function () {
      var _reloadCollectionPage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var response, text, parser, doc, newCollectionGrid, currentCollectionGrid, _t;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              _context4.n = 1;
              return fetch("/collections/".concat(this.collectionurl, "?").concat(this.params));
            case 1:
              response = _context4.v;
              if (response.ok) {
                _context4.n = 2;
                break;
              }
              throw new Error("error occured");
            case 2:
              _context4.n = 3;
              return response.text();
            case 3:
              text = _context4.v;
              parser = new DOMParser();
              doc = parser.parseFromString(text, "text/html");
              newCollectionGrid = doc.querySelector("#CollectionAjaxContent");
              currentCollectionGrid = document.querySelector("#CollectionAjaxContent");
              if (newCollectionGrid && currentCollectionGrid) {
                currentCollectionGrid.innerHTML = newCollectionGrid.innerHTML;
                currentCollectionGrid.classList.add("collection-updated");
                // Re-initialize desktop filter management after DOM update
                this.initializeDesktopFilterBehavior();
              }
              _context4.n = 5;
              break;
            case 4:
              _context4.p = 4;
              _t = _context4.v;
              // eslint-disable-next-line no-console
              console.log("error", _t);
            case 5:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 4]]);
      }));
      function reloadCollectionPage() {
        return _reloadCollectionPage.apply(this, arguments);
      }
      return reloadCollectionPage;
    }()
  }, {
    key: "addCategoryApplyButtonListeners",
    value: function addCategoryApplyButtonListeners() {
      var _this4 = this;
      var applyButtons = this.querySelectorAll(".category-apply-button");
      applyButtons.forEach(function (button) {
        button.addEventListener("click", /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(event) {
            var categoryId;
            return _regenerator().w(function (_context5) {
              while (1) switch (_context5.n) {
                case 0:
                  event.preventDefault();
                  categoryId = button.dataset.categoryId;
                  _context5.n = 1;
                  return _this4.applyCategoryFilters(categoryId);
                case 1:
                  return _context5.a(2);
              }
            }, _callee5);
          }));
          return function (_x3) {
            return _ref3.apply(this, arguments);
          };
        }());
      });
    }
  }, {
    key: "applyCategoryFilters",
    value: function () {
      var _applyCategoryFilters = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(categoryId) {
        var url, params, categoryFilters;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              url = new URL(window.location.href);
              params = new URLSearchParams(url.search);
              categoryFilters = this.pendingFiltersByCategory.get(categoryId);
              if (!categoryFilters) {
                _context6.n = 1;
                break;
              }
              // Apply all pending filters for this category
              categoryFilters.forEach(function (values, name) {
                // First remove ALL existing parameters for this filter type
                params["delete"](name);
                // Then add only the selected values (empty array means deselect all)
                values.forEach(function (value) {
                  params.append(name, value);
                });
              });
              url.search = params.toString();
              this.params = params.toString();
              window.history.pushState({}, "", url.toString());
              // Clear pending filters for this category
              this.pendingFiltersByCategory["delete"](categoryId);
              this.updateCategoryApplyButtonState(categoryId);
              _context6.n = 1;
              return this.reloadCollectionPage();
            case 1:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function applyCategoryFilters(_x4) {
        return _applyCategoryFilters.apply(this, arguments);
      }
      return applyCategoryFilters;
    }()
  }, {
    key: "updateCategoryApplyButtonState",
    value: function updateCategoryApplyButtonState(categoryId) {
      var applyButton = this.querySelector("[data-category-id=\"".concat(categoryId, "\"]"));
      if (applyButton) {
        var categoryFilters = this.pendingFiltersByCategory.get(categoryId);
        var hasPendingChanges = categoryFilters && categoryFilters.size > 0;
        // Always show the button
        applyButton.style.display = "block";
        if (hasPendingChanges) {
          var count = this.getCategoryPendingCount(categoryId);
          applyButton.textContent = "".concat(window.translationStrings.apply, " (").concat(count, ")");
          applyButton.classList.add("has-changes");
        } else {
          applyButton.textContent = window.translationStrings.apply;
          applyButton.classList.remove("has-changes");
        }
      }
    }
  }, {
    key: "getCategoryPendingCount",
    value: function getCategoryPendingCount(categoryId) {
      var categoryFilters = this.pendingFiltersByCategory.get(categoryId);
      if (!categoryFilters) return 0;
      var total = 0;
      categoryFilters.forEach(function (values) {
        total += values.length;
      });
      return total;
    }
  }, {
    key: "initializePendingFilters",
    value: function initializePendingFilters() {
      // Initialize pending filters to be empty - user starts with a clean slate
      this.pendingFiltersByCategory.clear();
      // Make sure all apply buttons are visible
      var applyButtons = this.querySelectorAll(".category-apply-button");
      applyButtons.forEach(function (button) {
        button.style.display = "block";
        button.textContent = window.translationStrings.apply;
      });
      // Restore visual states for all color swatches based on their checked state
      this.customFilterOptions.forEach(function (filterOption) {
        CustomFilters.updateColorSwatchVisualState(filterOption);
      });
    }
  }, {
    key: "initializeDesktopFilterBehavior",
    value: function initializeDesktopFilterBehavior() {
      // Re-initialize all component references after AJAX reload
      this.initData();
      // Re-initialize desktop filter management after AJAX reload
      var desktopFilters = document.querySelectorAll(".desktop-filter");
      // Close other filters when one opens
      desktopFilters.forEach(function (filter) {
        filter.addEventListener("toggle", function (event) {
          var targetFilter = event.target;
          if (targetFilter.open) {
            // Close all other filters
            desktopFilters.forEach(function (otherFilter) {
              if (otherFilter !== targetFilter && otherFilter.open) {
                otherFilter.open = false;
              }
            });
          }
        });
      });
      // Re-add all event listeners
      this.addEventlisteners();
      // Clear pending filters as we're starting fresh with the new DOM
      this.pendingFiltersByCategory.clear();
      // Reset all apply buttons to default state
      var applyButtons = this.querySelectorAll(".category-apply-button");
      applyButtons.forEach(function (button) {
        button.textContent = window.translationStrings.apply;
        button.classList.remove("has-changes");
      });
      // Restore visual states for all color swatches based on their checked state
      this.customFilterOptions.forEach(function (filterOption) {
        CustomFilters.updateColorSwatchVisualState(filterOption);
      });
    }
  }], [{
    key: "getCategoryIdFromCheckbox",
    value: function getCategoryIdFromCheckbox(checkbox) {
      // Find the closest desktop-filter parent to get the category ID
      var filterPanel = checkbox.closest(".desktop-filter__panel");
      if (filterPanel) {
        return filterPanel.id || "unknown";
      }
      return "unknown";
    }
  }, {
    key: "updateColorSwatchVisualState",
    value: function updateColorSwatchVisualState(checkbox) {
      var colorSwatch = checkbox.closest(".desktop-filter__color-swatch");
      if (colorSwatch) {
        if (checkbox.checked) {
          colorSwatch.classList.add("selected");
          colorSwatch.classList.add("tw:ring-2", "tw:ring-black", "tw:bg-[#E5DACD]");
          colorSwatch.classList.remove("tw:bg-[#F4EBE2]");
        } else {
          colorSwatch.classList.remove("selected");
          colorSwatch.classList.remove("tw:ring-2", "tw:ring-black", "tw:bg-[#E5DACD]");
          colorSwatch.classList.add("tw:bg-[#F4EBE2]");
        }
      }
    }
  }, {
    key: "arraysEqual",
    value: function arraysEqual(arr1, arr2) {
      if (arr1.length !== arr2.length) return false;
      return arr1.every(function (value, index) {
        return value === arr2[index];
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ },

/***/ "./resources/scripts/components/Geolocator/Geolocator.ts"
/*!***************************************************************!*\
  !*** ./resources/scripts/components/Geolocator/Geolocator.ts ***!
  \***************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Geolocator)
/* harmony export */ });
/* harmony import */ var _utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @utils/CookieMethods */ "./resources/scripts/utils/CookieMethods.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var Geolocator = /*#__PURE__*/function (_HTMLElement) {
  function Geolocator() {
    var _this;
    _classCallCheck(this, Geolocator);
    _this = _callSuper(this, Geolocator);
    _defineProperty(_this, "geolocatorScript", void 0);
    _defineProperty(_this, "countryDataArray", void 0);
    _defineProperty(_this, "geolocatorContentTemplate", void 0);
    _defineProperty(_this, "geolocatorContentPlaceholder", void 0);
    _defineProperty(_this, "modal", void 0);
    _defineProperty(_this, "closeModalButton", void 0);
    _defineProperty(_this, "closeCountryListModalButton", void 0);
    _defineProperty(_this, "countryModalToggle", void 0);
    _defineProperty(_this, "countryListModal", void 0);
    _defineProperty(_this, "countryListModalToggles", void 0);
    _defineProperty(_this, "countryListButtons", void 0);
    _defineProperty(_this, "stayButton", void 0);
    _defineProperty(_this, "leaveButton", void 0);
    _defineProperty(_this, "overlay", void 0);
    _this.getBrowsingContext = _this.getBrowsingContext.bind(_this);
    return _this;
  }
  _inherits(Geolocator, _HTMLElement);
  return _createClass(Geolocator, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var firstBlock, isCookied, browsingContext, activeCountry, recommendedMatch;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.initDataAndElements();
              this.addEventListeners();
              if (!(this.dataset.previewForceShow === "true")) {
                _context.n = 1;
                break;
              }
              firstBlock = this.countryDataArray[0];
              if (firstBlock) {
                this.toggleGeolocator();
                this.setupGeolocatorContent(firstBlock);
              }
              return _context.a(2);
            case 1:
              this.handleGeolocationCookie();
              isCookied = (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.getCookie)("geolocation");
              if (!isCookied) {
                _context.n = 2;
                break;
              }
              // eslint-disable-next-line no-console
              console.log("Geolocation cookie is set. Geolocator will not run.");
              return _context.a(2);
            case 2:
              _context.n = 3;
              return this.getBrowsingContext();
            case 3:
              browsingContext = _context.v;
              activeCountry = this.getActiveCountryAndLanguage();
              recommendedMatch = this.getRecommendedMatch(browsingContext); // If the recommended match is the same as the active country, return early as we do not need to show the geolocator
              var _isWrongStoreForGeo = false;
              if (recommendedMatch && recommendedMatch.type === "country" && recommendedMatch.url) {
                try { _isWrongStoreForGeo = new URL(recommendedMatch.url).hostname !== window.location.hostname; } catch (_e) { _isWrongStoreForGeo = false; }
              }
              if (!((recommendedMatch === null || recommendedMatch === void 0 ? void 0 : recommendedMatch.handle) === activeCountry.country) || _isWrongStoreForGeo) {
                _context.n = 4;
                break;
              }
              // eslint-disable-next-line no-console
              console.log("Recommended match is the same as the active country. Geolocator will not run.");
              return _context.a(2);
            case 4:
              this.toggleGeolocator();
              this.setupGeolocatorContent(recommendedMatch);
            case 5:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }, {
    key: "handleGeolocationCookie",
    value: function handleGeolocationCookie() {
      var urlParams = new URLSearchParams(window.location.search);
      var geolocation = urlParams.get("geolocation");
      if (geolocation) {
        (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.setCookie)("geolocation", geolocation, 30);
      }
    }
  }, {
    key: "toggleGeolocator",
    value: function toggleGeolocator() {
      var _this2 = this;
      this.classList.toggle("tw:hidden");
      this.setAttribute("geolocation-modal-active", this.getAttribute("geolocation-modal-active") === "true" ? "false" : "true");
      setTimeout(function () {
        _this2.modal.classList.toggle("active");
      }, 300);
    }
  }, {
    key: "setupGeolocatorContent",
    value: function setupGeolocatorContent(recommendedMatch) {
      var _this3 = this;
      var geolocatorContent = this.geolocatorContentTemplate.content.cloneNode(true);
      var content = geolocatorContent.querySelector("[data-id=\"".concat(recommendedMatch.id, "\"]"));
      if (content) {
        this.geolocatorContentPlaceholder.appendChild(content);
      }
      this.countryModalToggle = this.querySelector(".country-modal-toggle");
      this.stayButton = this.querySelector(".stay-button");
      this.leaveButton = this.querySelector(".leave-button");
      this.countryModalToggle.addEventListener("click", function (event) {
        event.preventDefault();
        _this3.toggleCountryListModal(_this3.countryModalToggle);
      });
      this.stayButton.addEventListener("click", function (event) {
        event.preventDefault();
        (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.setCookie)("geolocation", recommendedMatch.handle, 30);
        _this3.toggleGeolocator();
      });
      this.leaveButton.addEventListener("click", function (event) {
        event.preventDefault();
        var _this3$leaveButton$da = _this3.leaveButton.dataset,
          locale = _this3$leaveButton$da.locale,
          handle = _this3$leaveButton$da.handle,
          type = _this3$leaveButton$da.type,
          url = _this3$leaveButton$da.url;
        (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.setCookie)("geolocation", handle, 30);
        var isMarket = type === "market";
        if (!isMarket) {
          // For country type, use the external URL if provided
          if (url) {
            window.location.href = url;
          } else {
            window.location.href = "".concat(window.location.href, "?geolocation=").concat(handle);
          }
          return;
        }
        _this3.handleMarketSwitch(handle, locale);
      });
    }
  }, {
    key: "toggleCountryListModal",
    value: function toggleCountryListModal(trigger) {
      var geoLocatorActive = this.getAttribute("geolocation-modal-active") === "true";
      // make it boolean
      var isInModalTrigger = trigger.dataset.inmodaltoggle === "true";
      if (isInModalTrigger && !geoLocatorActive) {
        this.classList.toggle("tw:hidden");
        this.countryListModal.classList.toggle("active");
        return;
      }
      if (isInModalTrigger) {
        this.modal.classList.toggle("active");
        this.countryListModal.classList.toggle("active");
      } else {
        this.classList.toggle("tw:hidden");
        this.countryListModal.classList.add("active");
      }
    }
  }, {
    key: "initDataAndElements",
    value: function initDataAndElements() {
      this.modal = this.querySelector("#geolocator-modal");
      this.closeModalButton = this.querySelector("#close-geolocator-modal");
      this.geolocatorScript = this.querySelector("#geolocator-script");
      this.countryDataArray = JSON.parse(this.geolocatorScript.innerHTML);
      this.geolocatorContentTemplate = this.querySelector("#geolocator-content-tempalte");
      this.geolocatorContentPlaceholder = this.querySelector("#geolocator-content-placeholder");
      this.countryListModal = this.querySelector("#geolocator-countrylist-modal");
      this.closeCountryListModalButton = this.querySelector("#close-geolocator-countrylist-modal");
      this.countryListButtons = Array.from(this.querySelectorAll(".countrylist-button"));
      this.countryListModalToggles = Array.from(document.querySelectorAll(".country-modal-toggle"));
      this.overlay = this.querySelector(".geolocator-overlay");
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this$closeModalButto,
        _this4 = this;
      (_this$closeModalButto = this.closeModalButton) === null || _this$closeModalButto === void 0 || _this$closeModalButto.addEventListener("click", function (event) {
        event.preventDefault();
        _this4.toggleGeolocator();
      });
      this.closeCountryListModalButton.addEventListener("click", function (event) {
        event.preventDefault();
        _this4.toggleCountryListModal(_this4.closeCountryListModalButton);
      });
      this.countryListButtons.forEach(function (button) {
        button.addEventListener("click", function (event) {
          event.preventDefault();
          _this4.handleCountryListButtonClick(button);
        });
      });
      this.countryListModalToggles.forEach(function (toggle) {
        toggle === null || toggle === void 0 || toggle.addEventListener("click", function (event) {
          event.preventDefault();
          _this4.toggleCountryListModal(toggle);
        });
      });
    }
  }, {
    key: "handleCountryListButtonClick",
    value: function handleCountryListButtonClick(button) {
      (0,_utils_CookieMethods__WEBPACK_IMPORTED_MODULE_0__.setCookie)("geolocation", button.dataset.handle, 30);
      var isMarket = button.dataset.type === "market";
      if (!isMarket) {
        // For country type, use the external URL if provided
        var url = button.dataset.url;
        if (url) {
          window.location.href = url;
        } else {
          window.location.href = "".concat(window.location.href, "?geolocation=").concat(button.dataset.handle);
        }
        return;
      }
      var _button$dataset = button.dataset,
        locale = _button$dataset.locale,
        handle = _button$dataset.handle;
      this.handleMarketSwitch(handle, locale);
    }
  }, {
    key: "handleMarketSwitch",
    value: function handleMarketSwitch(handle, locale) {
      var formId = crypto.randomUUID();
      var formElement = document.createElement("form");
      formElement.id = formId;
      formElement.action = "/localization";
      formElement.method = "POST";
      formElement.hidden = true;
      formElement.innerHTML = "\n      <input name=\"_method\" value=\"PUT\">\n      <input name=\"country_code\" value=\"".concat(handle, "\">\n      <input name=\"language_code\" value=\"").concat(locale, "\">\n      <input name=\"return_to\" value=\"").concat(window.location.href, "?geolocation=").concat(handle, "\">\n    ");
      document.body.appendChild(formElement);
      formElement.submit();
    }
  }, {
    key: "getActiveCountryAndLanguage",
    value: function getActiveCountryAndLanguage() {
      var _window$Shopify = window.Shopify,
        country = _window$Shopify.country,
        locale = _window$Shopify.locale;
      return {
        country: country,
        locale: locale
      };
    }
  }, {
    key: "getRecommendedMatch",
    value: function getRecommendedMatch(browsingContext) {
      if (!browsingContext) return; // If no browsing context, return early
      var suggestedCountry = browsingContext.suggestedCountry,
        suggestedLanguage = browsingContext.suggestedLanguage,
        detectedCountry = browsingContext.detectedCountry;
      var countryHandle = (suggestedCountry === null || suggestedCountry === void 0 ? void 0 : suggestedCountry.handle) || (detectedCountry === null || detectedCountry === void 0 ? void 0 : detectedCountry.handle);
      var languageHandle = suggestedLanguage === null || suggestedLanguage === void 0 ? void 0 : suggestedLanguage.handle;
      if (!countryHandle) return;
      // Helper function to parse countries string into array
      var parseCountries = function parseCountries(countriesStr) {
        if (!countriesStr) return [];
        return countriesStr.split(",").map(function (c) {
          return c.trim().toUpperCase();
        }).filter(function (c) {
          return c.length > 0;
        });
      };
      // Helper function to check if a country is in a market's country list
      var isCountryInMarket = function isCountryInMarket(market, country) {
        var countries = parseCountries(market.countries || "");
        // If no countries defined, check if handle matches (single-country market)
        if (countries.length === 0) {
          return market.handle.toUpperCase() === country.toUpperCase();
        }
        // Check if country is in the list
        return countries.includes(country.toUpperCase());
      };
      // Look for an exact match (country in market's country list & matching language)
      var recommendedMatch = this.countryDataArray.find(function (market) {
        return isCountryInMarket(market, countryHandle) && market.locale === languageHandle;
      });
      // If no exact match, look for a market that contains this country (any language)
      if (!recommendedMatch) {
        recommendedMatch = this.countryDataArray.find(function (market) {
          return isCountryInMarket(market, countryHandle);
        });
      }
      // If still no match, find the primary market
      if (!recommendedMatch) {
        recommendedMatch = this.countryDataArray.find(function (market) {
          return market.primary;
        });
      }
      // In the end we either have
      // 1. An exact match on country (in market's country list) and language
      // 2. A match on country only (in market's country list)
      // 3. A match on primary market
      // eslint-disable-next-line consistent-return
      return recommendedMatch;
    }
  }, {
    key: "getBrowsingContext",
    value: function () {
      var _getBrowsingContext = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var response, data, detectedValues, _detectedValues$count, handle, name, suggestions, suggestedCountry, suggestedLanguage, suggestion, browsingContext;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return fetch("/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true");
            case 1:
              response = _context2.v;
              _context2.n = 2;
              return response.json();
            case 2:
              data = _context2.v;
              detectedValues = data.detected_values;
              _detectedValues$count = detectedValues.country, handle = _detectedValues$count.handle, name = _detectedValues$count.name;
              suggestions = data.suggestions;
              suggestedCountry = null;
              suggestedLanguage = null;
              if (suggestions.length) {
                // Check if there is a suggestion who has parts.country.handle which is equal to detectedValues.country.handle
                suggestion = suggestions.find(function (_suggestion) {
                  return _suggestion.parts.country.handle === detectedValues.country.handle;
                });
                suggestedCountry = suggestion === null || suggestion === void 0 ? void 0 : suggestion.parts.country;
                suggestedLanguage = suggestion === null || suggestion === void 0 ? void 0 : suggestion.parts.language;
              }
              browsingContext = {
                detectedCountry: {
                  handle: handle,
                  name: name
                },
                suggestedCountry: suggestedCountry,
                suggestedLanguage: suggestedLanguage
              };
              return _context2.a(2, browsingContext);
          }
        }, _callee2);
      }));
      function getBrowsingContext() {
        return _getBrowsingContext.apply(this, arguments);
      }
      return getBrowsingContext;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ },

/***/ "./resources/scripts/components/PredictiveSearch/PredictiveSearch.ts"
/*!***************************************************************************!*\
  !*** ./resources/scripts/components/PredictiveSearch/PredictiveSearch.ts ***!
  \***************************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ PredictiveSearch)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PredictiveSearch = /*#__PURE__*/function (_HTMLElement) {
  function PredictiveSearch() {
    var _this;
    _classCallCheck(this, PredictiveSearch);
    _this = _callSuper(this, PredictiveSearch);
    _defineProperty(_this, "searchInput", null);
    _defineProperty(_this, "predictiveSearchResultsContainer", null);
    _defineProperty(_this, "closeButton", null);
    _defineProperty(_this, "popularSearchTermElements", []);
    _defineProperty(_this, "debounceTimeout", null);
    _defineProperty(_this, "debounceDelay", 300);
    _defineProperty(_this, "pagesSearchEnabled", void 0);
    _defineProperty(_this, "articlesSearchEnabled", void 0);
    _defineProperty(_this, "collectionsSearchEnabled", void 0);
    _defineProperty(_this, "resourceLimit", void 0);
    _defineProperty(_this, "resourceLimitScope", void 0);
    _defineProperty(_this, "unavailableProductsHandling", void 0);
    _defineProperty(_this, "predictiveSearchURL", void 0);
    _defineProperty(_this, "sectionId", void 0);
    _defineProperty(_this, "initialHtml", "");
    _defineProperty(_this, "predictiveSearchComponentToggles", []);
    _defineProperty(_this, "predictiveSearchComponent", null);
    _defineProperty(_this, "resourceOptionsFields", ["author", "body", "product_type", "tag", "title", "variants.barcode", "variants.sku", "variants.title", "vendor"]);
    _this.initDataAndElements = _this.initDataAndElements.bind(_this);
    _this.addEventListeners = _this.addEventListeners.bind(_this);
    _this.handleSearchInput = _this.handleSearchInput.bind(_this);
    return _this;
  }
  _inherits(PredictiveSearch, _HTMLElement);
  return _createClass(PredictiveSearch, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initDataAndElements();
      this.addEventListeners();
    }
  }, {
    key: "initDataAndElements",
    value: function initDataAndElements() {
      this.pagesSearchEnabled = this.dataset.pagesSearchEnabled === "true";
      this.articlesSearchEnabled = this.dataset.articlesSearchEnabled === "true";
      this.collectionsSearchEnabled = this.dataset.collectionsSearchEnabled === "true";
      this.resourceLimit = parseInt(this.dataset.resourceLimit || "5", 10);
      this.resourceLimitScope = this.dataset.resourceLimitScope === "each" ? "each" : "all";
      this.unavailableProductsHandling = ["hide", "show", "last"].includes(this.dataset.unavailableProductsHandling || "") ? this.dataset.unavailableProductsHandling : "show";
      this.predictiveSearchURL = this.dataset.predictiveSearchUrl;
      this.sectionId = this.dataset.sectionId;
      this.searchInput = this.querySelector("input[type='search']");
      this.predictiveSearchResultsContainer = this.querySelector("#edition-predictive-search-results-container");
      this.popularSearchTermElements = Array.from(this.querySelectorAll(".popular-search-term"));
      this.closeButton = this.querySelector("#edition-predictive-search-close-button");
      this.initialHtml = this.predictiveSearchResultsContainer ? this.predictiveSearchResultsContainer.innerHTML : "";
      this.predictiveSearchComponent = this;
      this.predictiveSearchComponentToggles = Array.from(document.querySelectorAll(".search-bar-nav"));
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this2 = this;
      // enter key to perform search on /search
      this.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          var target = event.target;
          if (target === _this2.searchInput) {
            var _this2$searchInput;
            event.preventDefault();
            var searchTerm = ((_this2$searchInput = _this2.searchInput) === null || _this2$searchInput === void 0 ? void 0 : _this2$searchInput.value.trim()) || "";
            if (searchTerm.length > 0) {
              // Submit formularen i stedet for at bygge URL'en i haanden.
              // Den haandbyggede variant droppede baade type og options[prefix],
              // saa soegesiden returnerede alle ressourcetyper og sider dukkede
              // op som graa tekstkort i produktgitteret. Den hardcodede ogsaa
              // "/search" uden sprogpraefiks, hvilket sender en hollandsk eller
              // finsk kunde paa COM over i standardsproget. Formularens action er
              // routes.search_url og er sprogbevidst.
              var searchForm = _this2.searchInput.form;
              if (searchForm) {
                if (searchForm.requestSubmit) {
                  searchForm.requestSubmit();
                } else {
                  searchForm.submit();
                }
              } else {
                window.location.href = "/search?q=".concat(encodeURIComponent(searchTerm));
              }
            }
          }
        }
      });
      // escape key to close search
      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
          event.preventDefault();
          _this2.toggleSearchInput(false);
        }
      });
      // Click outside to close search
      document.addEventListener("click", function (event) {
        var _this2$predictiveSear;
        var target = event.target;
        var isClickInside = ((_this2$predictiveSear = _this2.predictiveSearchComponent) === null || _this2$predictiveSear === void 0 ? void 0 : _this2$predictiveSear.contains(target)) || false;
        var isToggleButton = _this2.predictiveSearchComponentToggles.some(function (toggle) {
          return toggle.contains(target);
        });
        if (!isClickInside && !isToggleButton) {
          _this2.toggleSearchInput(false);
        }
      });
      this.predictiveSearchComponentToggles.forEach(function (toggle) {
        toggle.addEventListener("click", function (event) {
          var _this2$predictiveSear2;
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          var isVisible = ((_this2$predictiveSear2 = _this2.predictiveSearchComponent) === null || _this2$predictiveSear2 === void 0 ? void 0 : _this2$predictiveSear2.classList.contains("is-visible")) || false;
          _this2.toggleSearchInput(!isVisible);
        });
      });
      if (this.searchInput) {
        this.searchInput.addEventListener("input", this.handleSearchInput);
      }
      // Populaere soegninger: event delegation i stedet for én listener pr. node.
      //
      // handleClearSearch og luk af panelet saetter
      //   predictiveSearchResultsContainer.innerHTML = this.initialHtml
      // hvilket destruerer .popular-search-term-ankrene og bygger nye. De nye
      // havde ingen listener, fordi addEventListeners kun koerer én gang i
      // connectedCallback. Maalt paa pitaya.dk 15/9-2026: alle fire chips
      // virkede ved foerste aabning efter page load, og INGEN virkede efter
      // luk + genaabn.
      //
      // Delegationen sidder paa selve komponenten, som aldrig udskiftes, saa
      // den overlever enhver gentegning af panelet. Flaget beskytter mod
      // dobbeltbinding hvis elementet gentilkobles i DOM'en.
      //
      // .trim() er med vilje: data-term har tidligere haft foranstillet
      // mellemrum fra newline_to_br-parsningen i snippet'en.
      if (!this.popularSearchDelegationBound) {
        this.popularSearchDelegationBound = true;
        this.addEventListener("click", function (event) {
          var target = event.target;
          var element = target && target.closest ? target.closest(".popular-search-term") : null;
          if (!element || !_this2.contains(element)) return;
          event.preventDefault();
          var searchTerm = (element.dataset.term || "").trim();
          if (searchTerm.length === 0 || !_this2.searchInput) return;
          _this2.searchInput.value = searchTerm;
          _this2.performSearch(searchTerm);
        });
      }
      if (this.closeButton) {
        this.closeButton.addEventListener("click", function (event) {
          event.preventDefault();
          if (_this2.searchInput) {
            _this2.handleClearSearch();
          }
        });
      }
      // handle click inside. Some themes might try to close the search on any click.
      this.addEventListener("click", function (event) {
        event.stopPropagation();
      });
    }
  }, {
    key: "handleSearchInput",
    value: function handleSearchInput(event) {
      var _this3 = this;
      var target = event.target;
      var searchTerm = target.value.trim();
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }
      this.debounceTimeout = window.setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(searchTerm.length > 0)) {
                _context.n = 1;
                break;
              }
              _context.n = 1;
              return _this3.performSearch(searchTerm);
            case 1:
              _this3.toggleCloseButton(searchTerm.length > 0);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      })), this.debounceDelay);
    }
  }, {
    key: "toggleCloseButton",
    value: function toggleCloseButton(show) {
      if (this.closeButton) {
        this.closeButton.classList.toggle("is-visible", show);
      }
    }
  }, {
    key: "performSearch",
    value: function () {
      var _performSearch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(searchTerm) {
        var searchURL, response, text, doc, resultsContainer, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.toggleLoadingOverlay(true);
              searchURL = this.buildSearchURL(searchTerm);
              _context2.p = 1;
              _context2.n = 2;
              return fetch(searchURL);
            case 2:
              response = _context2.v;
              if (response.ok) {
                _context2.n = 3;
                break;
              }
              throw new Error("Network response was not ok: ".concat(response.statusText));
            case 3:
              _context2.n = 4;
              return response.text();
            case 4:
              text = _context2.v;
              doc = new DOMParser().parseFromString(text, "text/html");
              resultsContainer = doc.querySelector("#edition-predictive-search-results-container");
              if (this.predictiveSearchResultsContainer && resultsContainer) {
                this.predictiveSearchResultsContainer.innerHTML = resultsContainer.innerHTML;
              }
              _context2.n = 6;
              break;
            case 5:
              _context2.p = 5;
              _t = _context2.v;
              console.error("Error performing predictive search:", _t);
            case 6:
              _context2.p = 6;
              this.toggleLoadingOverlay(false);
              return _context2.f(6);
            case 7:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 5, 6, 7]]);
      }));
      function performSearch(_x) {
        return _performSearch.apply(this, arguments);
      }
      return performSearch;
    }()
  }, {
    key: "buildSearchURL",
    value: function buildSearchURL(searchTerm) {
      var url = new URL(window.location.origin + this.predictiveSearchURL);
      if (searchTerm) {
        url.searchParams.set("q", searchTerm);
      }
      url.searchParams.set("resources[type]", this.getResourceTypes().join(","));
      url.searchParams.set("resources[options][fields]", this.getResourceOptionsFields().join(","));
      url.searchParams.set("resources[limit]", this.resourceLimit.toString());
      url.searchParams.set("resources[limit_scope]", this.resourceLimitScope);
      url.searchParams.set("resources[unavailable_products]", this.unavailableProductsHandling);
      url.searchParams.set("section_id", this.sectionId);
      return url.toString();
    }
  }, {
    key: "getResourceTypes",
    value: function getResourceTypes() {
      var types = ["product"];
      if (this.pagesSearchEnabled) {
        types.push("page");
      }
      if (this.articlesSearchEnabled) {
        types.push("article");
      }
      if (this.collectionsSearchEnabled) {
        types.push("collection");
      }
      return types;
    }
  }, {
    key: "getResourceOptionsFields",
    value: function getResourceOptionsFields() {
      return this.resourceOptionsFields;
    }
  }, {
    key: "toggleLoadingOverlay",
    value: function toggleLoadingOverlay(show) {
      var loadingOverlay = this.querySelector("#edition-predictive-search-loading-overlay");
      if (loadingOverlay) {
        loadingOverlay.classList.toggle("is-active", show);
      }
    }
  }, {
    key: "handleClearSearch",
    value: function handleClearSearch() {
      if (this.searchInput) {
        this.searchInput.value = "";
        if (this.predictiveSearchResultsContainer) {
          this.predictiveSearchResultsContainer.innerHTML = this.initialHtml;
          this.toggleCloseButton(false);
        }
      }
    }
  }, {
    key: "toggleSearchInput",
    value: function toggleSearchInput(show) {
      if (this.predictiveSearchComponent) {
        document.body.classList.toggle("predictive-search-open", show);
        this.predictiveSearchComponent.classList.toggle("is-visible", show);
        // Focus the input when opening
        if (show && this.searchInput) {
          this.searchInput.focus();
        }
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ },

/***/ "./resources/scripts/components/RemoveAll/RemoveAll.ts"
/*!*************************************************************!*\
  !*** ./resources/scripts/components/RemoveAll/RemoveAll.ts ***!
  \*************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ RemoveAll)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var RemoveAll = /*#__PURE__*/function (_HTMLElement) {
  function RemoveAll() {
    var _this;
    _classCallCheck(this, RemoveAll);
    _this = _callSuper(this, RemoveAll);
    _defineProperty(_this, "id", _this.dataset.id);
    _this.handleRemoveAll = _this.handleRemoveAll.bind(_this);
    return _this;
  }
  _inherits(RemoveAll, _HTMLElement);
  return _createClass(RemoveAll, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.addEventListener("click", /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                event.preventDefault();
                _context.n = 1;
                return _this2.handleRemoveAll();
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "handleRemoveAll",
    value: function () {
      var _handleRemoveAll = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var response, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return fetch("/cart/change.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  id: this.id,
                  quantity: 0
                })
              });
            case 1:
              response = _context2.v;
              if (response.ok) {
                _context2.n = 2;
                break;
              }
              throw new Error("HTTP error status: ".concat(response.status));
            case 2:
              document.dispatchEvent(new CustomEvent("cart:build"));
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              console.log("error", _t);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 3]]);
      }));
      function handleRemoveAll() {
        return _handleRemoveAll.apply(this, arguments);
      }
      return handleRemoveAll;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ },

/***/ "./resources/scripts/components/ShopTheLook/ShopTheLook.ts"
/*!*****************************************************************!*\
  !*** ./resources/scripts/components/ShopTheLook/ShopTheLook.ts ***!
  \*****************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ShopTheLook)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ShopTheLook = /*#__PURE__*/function (_HTMLElement) {
  function ShopTheLook() {
    var _this;
    _classCallCheck(this, ShopTheLook);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ShopTheLook, [].concat(args));
    _defineProperty(_this, "dots", null);
    _defineProperty(_this, "handlers", new WeakMap());
    return _this;
  }
  _inherits(ShopTheLook, _HTMLElement);
  return _createClass(ShopTheLook, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this$dots,
        _this2 = this,
        _this$dots2;
      this.dots = this.querySelectorAll(".stl-dot");
      var container = this.querySelector(".stl-image-wrap");
      var popovers = this.querySelectorAll(".stl-popover");
      (_this$dots = this.dots) === null || _this$dots === void 0 || _this$dots.forEach(function (dot) {
        _this2.clampDotToContainer(dot, container);
        var pop = _this2.getPopover(dot);
        if (pop) _this2.placePopover(pop, container);
      });
      (_this$dots2 = this.dots) === null || _this$dots2 === void 0 || _this$dots2.forEach(function (dot) {
        var enter = function enter(e) {
          return _this2.showDotPopover(e.currentTarget, container);
        };
        var leave = function leave(e) {
          var btn = e.currentTarget;
          var pop = _this2.getPopover(btn);
          var related = e.relatedTarget;
          if (related && (pop !== null && pop !== void 0 && pop.contains(related) || btn.contains(related))) return;
          _this2.hideDotPopover(btn);
        };
        var click = function click(e) {
          var _this2$dots;
          e.preventDefault();
          var btn = e.currentTarget;
          var expanded = btn.getAttribute("aria-expanded") === "true";
          popovers.forEach(function (p) {
            p.style.display = "none";
          });
          (_this2$dots = _this2.dots) === null || _this2$dots === void 0 || _this2$dots.forEach(function (d) {
            return d.setAttribute("aria-expanded", "false");
          });
          if (!expanded) _this2.showDotPopover(btn, container, true);
        };
        _this2.handlers.set(dot, {
          enter: enter,
          leave: leave,
          click: click
        });
        dot.addEventListener("mouseenter", enter);
        dot.addEventListener("mouseleave", leave);
        dot.addEventListener("click", click);
        dot.addEventListener("keydown", function (ev) {
          if (ev.key === "Escape") _this2.hideDotPopover(dot);
          if (ev.key === "Enter" || ev.key === " ") {
            ev.preventDefault();
            dot.click();
          }
        });
      });
      // Click outside to close
      document.addEventListener("click", function (evt) {
        if (!_this2.contains(evt.target)) {
          var _this2$dots2;
          popovers.forEach(function (p) {
            p.style.display = "none";
          });
          (_this2$dots2 = _this2.dots) === null || _this2$dots2 === void 0 || _this2$dots2.forEach(function (d) {
            return d.setAttribute("aria-expanded", "false");
          });
        }
      });
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _this$dots3,
        _this3 = this;
      (_this$dots3 = this.dots) === null || _this$dots3 === void 0 || _this$dots3.forEach(function (dot) {
        var h = _this3.handlers.get(dot);
        if (!h) return;
        dot.removeEventListener("mouseenter", h.enter);
        dot.removeEventListener("mouseleave", h.leave);
        dot.removeEventListener("click", h.click);
        _this3.handlers["delete"](dot);
      });
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "clampDotToContainer",
    value: function clampDotToContainer(dot, _container) {
      var x = ShopTheLook.num(dot.dataset.dotX, 50);
      var y = ShopTheLook.num(dot.dataset.dotY, 50);
      var clampedX = ShopTheLook.clamp(x, 0, 100);
      var clampedY = ShopTheLook.clamp(y, 0, 100);
      dot.style.left = "".concat(clampedX, "%");
      dot.style.top = "".concat(clampedY, "%");
      dot.dataset.dotX = String(clampedX);
      dot.dataset.dotY = String(clampedY);
      dot.style.translate = "-50% -50%";
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "getPopover",
    value: function getPopover(dot) {
      var _wrap$querySelector;
      var wrap = dot.closest(".stl-dot-container");
      return (_wrap$querySelector = wrap === null || wrap === void 0 ? void 0 : wrap.querySelector(".stl-popover")) !== null && _wrap$querySelector !== void 0 ? _wrap$querySelector : null;
    }
  }, {
    key: "showDotPopover",
    value: function showDotPopover(dot, container) {
      var _this4 = this;
      var persist = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var pop = this.getPopover(dot);
      if (!pop) return;
      pop.style.display = "block";
      dot.setAttribute("aria-expanded", "true");
      this.placePopover(pop, container);
      if (!persist) {
        var _onLeave = function onLeave(e) {
          var related = e.relatedTarget;
          if (related && (pop.contains(related) || dot.contains(related))) return;
          _this4.hideDotPopover(dot);
          pop.removeEventListener("mouseleave", _onLeave);
        };
        pop.addEventListener("mouseleave", _onLeave);
      }
    }
  }, {
    key: "hideDotPopover",
    value: function hideDotPopover(dot) {
      var pop = this.getPopover(dot);
      if (!pop) return;
      pop.style.display = "none";
      dot.setAttribute("aria-expanded", "false");
    }
  }, {
    key: "placePopover",
    value: function placePopover(pop, container) {
      if (!container) return;
      var cRect = container.getBoundingClientRect();
      var pRect = pop.getBoundingClientRect();
      var pad = 8;
      var leftPercent = this.extractPercent(pop.style.left, 50);
      var topPercent = this.extractPercent(pop.style.top, 50);
      var leftPx = cRect.left + leftPercent / 100 * cRect.width;
      var topPx = cRect.top + topPercent / 100 * cRect.height;
      var currentTranslate = this.parseTranslate(pop.style.translate || "-50% -100%");
      var _currentTranslate = _slicedToArray(currentTranslate, 2),
        tx = _currentTranslate[0],
        ty = _currentTranslate[1];
      var txPx = tx / 100 * pRect.width;
      var tyPx = ty / 100 * pRect.height;
      var boxLeft = leftPx + txPx;
      var boxTop = topPx + tyPx;
      var corrX = 0;
      var corrY = 0;
      if (boxLeft < cRect.left + pad) corrX = cRect.left + pad - boxLeft;
      if (boxLeft + pRect.width > cRect.right - pad) corrX = cRect.right - pad - (boxLeft + pRect.width);
      if (boxTop < cRect.top + pad) corrY = cRect.top + pad - boxTop;
      if (boxTop + pRect.height > cRect.bottom - pad) corrY = cRect.bottom - pad - (boxTop + pRect.height);
      tx += corrX / pRect.width * 100;
      ty += corrY / pRect.height * 100;
      pop.style.translate = "".concat(tx, "% ").concat(ty, "%");
    }
  }, {
    key: "extractPercent",
    value:
    // eslint-disable-next-line class-methods-use-this
    function extractPercent(cssValue) {
      var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (!cssValue || !cssValue.endsWith("%")) return fallback;
      var n = Number(cssValue.replace("%", ""));
      return Number.isFinite(n) ? n : fallback;
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "parseTranslate",
    value: function parseTranslate(translate) {
      var _parts$, _parts$2;
      // expects "<x>% <y>%"
      var parts = translate.split(/\s+/);
      var x = (_parts$ = parts[0]) !== null && _parts$ !== void 0 && _parts$.endsWith("%") ? Number(parts[0].replace("%", "")) : -50;
      var y = (_parts$2 = parts[1]) !== null && _parts$2 !== void 0 && _parts$2.endsWith("%") ? Number(parts[1].replace("%", "")) : -100;
      return [Number.isFinite(x) ? x : -50, Number.isFinite(y) ? y : -100];
    }
  }], [{
    key: "clamp",
    value: function clamp(n, min, max) {
      return Math.max(min, Math.min(max, n));
    }
  }, {
    key: "num",
    value: function num(v, fallback) {
      var n = Number(v);
      return Number.isFinite(n) ? n : fallback;
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ },

/***/ "./resources/scripts/components/Wishlist/Wishlist.ts"
/*!***********************************************************!*\
  !*** ./resources/scripts/components/Wishlist/Wishlist.ts ***!
  \***********************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Wishlist)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable no-empty */
/* eslint-disable class-methods-use-this */
var Wishlist = /*#__PURE__*/function (_HTMLElement) {
  function Wishlist() {
    var _this;
    _classCallCheck(this, Wishlist);
    _this = _callSuper(this, Wishlist);
    _defineProperty(_this, "url", void 0);
    _this.addEventListeners = _this.addEventListeners.bind(_this);
    _this.renderWishlistItems = _this.renderWishlistItems.bind(_this);
    _this.generateWishlistItems = _this.generateWishlistItems.bind(_this);
    return _this;
  }
  _inherits(Wishlist, _HTMLElement);
  return _createClass(Wishlist, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.url = this.dataset.url;
              this.addEventListeners();
              // Only render items if this component has a URL (i.e., it's the main wishlist page component)
              if (!this.url) {
                _context.n = 1;
                break;
              }
              _context.n = 1;
              return this.renderWishlistItems();
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this2 = this;
      document.addEventListener("wishlistUpdated", /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_event) {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                _context2.n = 1;
                return _this2.renderWishlistItems();
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "renderWishlistItems",
    value: function () {
      var _renderWishlistItems = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var currentWishlist, parsedWishlist, wishlistItemsHtml;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              currentWishlist = localStorage.getItem("wishlist");
              parsedWishlist = currentWishlist ? JSON.parse(currentWishlist) : [];
              // Ryd KUN naar listen er tom. Foer stod this.innerHTML = "" her, dvs.
              // hele gitteret blev toemt foer de nye kort var hentet. Med 10 produkter
              // er det 10 parallelle fetch-kald, og i hele det vindue stod siden tom -
              // det er den flimren man ser naar man fjerner ét produkt. Nu bliver det
              // gamle indhold staaende indtil det nye er klar (assignment i case 2).
              if (!(parsedWishlist.length === 0)) {
                _context3.n = 1;
                break;
              }
              this.innerHTML = "";
              return _context3.a(2);
            case 1:
              _context3.n = 2;
              return this.generateWishlistItems(parsedWishlist);
            case 2:
              wishlistItemsHtml = _context3.v;
              this.innerHTML = wishlistItemsHtml;
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function renderWishlistItems() {
        return _renderWishlistItems.apply(this, arguments);
      }
      return renderWishlistItems;
    }()
  }, {
    key: "generateWishlistItems",
    value: function () {
      var _generateWishlistItems = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(parsedWishlist) {
        var _this3 = this;
        var batchSize, batches, idsArray, i, responses, template, wishlitItemsHtml, _t;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              if (this.url) {
                _context4.n = 1;
                break;
              }
              // eslint-disable-next-line no-console
              console.error("Wishlist component: data-url is missing");
              return _context4.a(2, "");
            case 1:
              batchSize = 1;
              batches = [];
              idsArray = parsedWishlist.map(function (id) {
                return "id:".concat(id);
              }); // eslint-disable-next-line no-console
              for (i = 0; i < idsArray.length; i += batchSize) {
                batches.push(idsArray.slice(i, i + batchSize).join(" OR "));
              }
              _context4.n = 2;
              return Promise.all(batches.map(function (batchQuery) {
                return fetch("".concat(_this3.url, "&q=").concat(batchQuery)).then(function (res) {
                  if (!res.ok) throw new Error("Network response was not ok: ".concat(res.status));
                  return res.text().then(function (text) {
                    return text;
                  });
                });
              }));
            case 2:
              responses = _context4.v;
              template = document.createElement("template");
              wishlitItemsHtml = responses.map(function (response, _index) {
                template.innerHTML = response;
                var wishlistItemsWrapper = template.content.querySelector("wishlist-component");
                return wishlistItemsWrapper ? Array.from(wishlistItemsWrapper.children).map(function (child) {
                  return child.outerHTML;
                }).join("") : "";
              }).join("");
              return _context4.a(2, wishlitItemsHtml);
            case 3:
              _context4.p = 3;
              _t = _context4.v;
              // eslint-disable-next-line no-console
              console.error("Wishlist generateWishlistItems error:", _t);
              return _context4.a(2, "");
          }
        }, _callee4, this, [[0, 3]]);
      }));
      function generateWishlistItems(_x2) {
        return _generateWishlistItems.apply(this, arguments);
      }
      return generateWishlistItems;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ },

/***/ "./resources/scripts/components/Wishlist/WishlistButton.ts"
/*!*****************************************************************!*\
  !*** ./resources/scripts/components/Wishlist/WishlistButton.ts ***!
  \*****************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ WishlistButton)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var WishlistButton = /*#__PURE__*/function (_HTMLElement) {
  function WishlistButton() {
    var _this;
    _classCallCheck(this, WishlistButton);
    _this = _callSuper(this, WishlistButton);
    _defineProperty(_this, "id", void 0);
    _this.addEventListeners = _this.addEventListeners.bind(_this);
    _this.toggleProductInWishlist = _this.toggleProductInWishlist.bind(_this);
    _this.checkIfProductIsInWishlist = _this.checkIfProductIsInWishlist.bind(_this);
    return _this;
  }
  _inherits(WishlistButton, _HTMLElement);
  return _createClass(WishlistButton, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.id = this.dataset.id;
      this.checkIfProductIsInWishlist();
      this.addEventListeners();
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this2 = this;
      this.addEventListener("click", function (event) {
        event.preventDefault();
        _this2.toggleProductInWishlist();
        _this2.animateWishlistButton(event);
      });
    }
  }, {
    key: "toggleProductInWishlist",
    value: function toggleProductInWishlist() {
      var _this3 = this;
      var wishlist = localStorage.getItem("wishlist");
      var parsedWishlist = wishlist ? JSON.parse(wishlist) : [];
      // Wishlist is an array of handles
      var productIndex = parsedWishlist.findIndex(function (item) {
        return item === _this3.id;
      });
      if (productIndex !== -1) {
        parsedWishlist.splice(productIndex, 1); // Remove product
      } else {
        parsedWishlist.push(this.id); // Add product
      }
      localStorage.setItem("wishlist", JSON.stringify(parsedWishlist));
      this.classList.toggle("added-to-wishlist");
      // Dispatch event to update wishlist count
      var wishlistUpdatedEvent = new CustomEvent("wishlistUpdated", {
        detail: {
          wishlistCount: parsedWishlist.length,
          rerender: true
        }
      });
      document.dispatchEvent(wishlistUpdatedEvent);
    }
  }, {
    key: "checkIfProductIsInWishlist",
    value: function checkIfProductIsInWishlist() {
      var wishlist = localStorage.getItem("wishlist");
      if (wishlist) {
        var parsedWishlist = JSON.parse(wishlist);
        if (parsedWishlist.includes(this.id)) {
          this.classList.add("added-to-wishlist");
        }
      }
    }
  }, {
    key: "animateWishlistButton",
    value: function animateWishlistButton(event) {
      var particleWrapper = this.querySelector(".particles-wrapper");
      if (!particleWrapper) return;
      // Get the correct coordinates based on the event type
      var clientX;
      var clientY;
      if (event instanceof MouseEvent) {
        clientX = event.clientX;
        clientY = event.clientY;
      } else if (event instanceof TouchEvent) {
        clientX = event.touches[0].clientX;
        clientY = event.touches[0].clientY;
      } else {
        return;
      }
      // Calculate position relative to particleWrapper
      var rect = particleWrapper.getBoundingClientRect();
      var offsetX = clientX - rect.left;
      var offsetY = clientY - rect.top;
      var _loop = function _loop() {
        var particle = document.createElement("div");
        particle.classList.add("particles");
        // Randomize movement direction
        var angle = Math.random() * 2 * Math.PI;
        var distance = Math.random() * 20 + 10; // Spread particles outwards
        var x = Math.cos(angle) * distance;
        var y = Math.sin(angle) * distance;
        // Position relative to click/touch
        particle.style.left = "".concat(offsetX, "px");
        particle.style.top = "".concat(offsetY, "px");
        particle.style.setProperty("--x", "".concat(x, "px"));
        particle.style.setProperty("--y", "".concat(y, "px"));
        particleWrapper.appendChild(particle);
        // Remove particle after animation (matching duration in CSS)
        setTimeout(function () {
          return particle.remove();
        }, 2000);
      };
      for (var i = 0; i < 15; i += 1) {
        _loop();
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ },

/***/ "./resources/scripts/components/lowStock/lowStock.ts"
/*!***********************************************************!*\
  !*** ./resources/scripts/components/lowStock/lowStock.ts ***!
  \***********************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ LowStock)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var LowStock = /*#__PURE__*/function (_HTMLElement) {
  function LowStock() {
    var _this;
    _classCallCheck(this, LowStock);
    _this = _callSuper(this, LowStock);
    _defineProperty(_this, "productUrl", _this.dataset.producturl);
    _defineProperty(_this, "url", _this.dataset.url);
    _defineProperty(_this, "eventListenersAdded", _this.dataset.eventlistenersAdded === "true");
    _this.addEventListeners = _this.addEventListeners.bind(_this);
    _this.handleComponentUpdate = _this.handleComponentUpdate.bind(_this);
    return _this;
  }
  _inherits(LowStock, _HTMLElement);
  return _createClass(LowStock, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.addEventListeners();
      console.log("InventoryDeliveryComponent connected");
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _window,
        _window$lowStockVaria,
        _this2 = this;
      (_window$lowStockVaria = (_window = window).lowStockVariantListenerAdded) !== null && _window$lowStockVaria !== void 0 ? _window$lowStockVaria : _window.lowStockVariantListenerAdded = false;
      if (window.lowStockVariantListenerAdded) {
        this.eventListenersAdded = true;
        return;
      }
      if (!this.eventListenersAdded) {
        document.addEventListener("variant:change", function (event) {
          var variantId = event.detail.variant.id;
          _this2.handleComponentUpdate(variantId);
        });
        window.lowStockVariantListenerAdded = true;
        this.eventListenersAdded = true;
      }
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      console.log("InventoryDeliveryComponent disconnected");
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "handleComponentUpdate",
    value: function () {
      var _handleComponentUpdate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(variantId) {
        var baseUrl, response, error, data, freshComponent, currentComponent, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              baseUrl = "".concat(this.url).concat(this.productUrl, "?variant=").concat(variantId);
              console.log("LowStock component updating", baseUrl);
              _context.p = 1;
              _context.n = 2;
              return fetch("".concat(baseUrl, "?section_id=main-product"));
            case 2:
              response = _context.v;
              if (response.ok) {
                _context.n = 3;
                break;
              }
              error = new Error("HTTP error! status: ".concat(response.status));
              throw error;
            case 3:
              _context.n = 4;
              return response.text();
            case 4:
              data = _context.v;
              freshComponent = new DOMParser().parseFromString(data, "text/html").querySelector("low-stock");
              if (freshComponent) {
                currentComponent = document.querySelector("low-stock");
                if (currentComponent !== freshComponent && currentComponent.parentNode) {
                  // Use parentNode.replaceChild for better iOS Safari compatibility
                  currentComponent.parentNode.replaceChild(freshComponent, currentComponent);
                }
              }
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              console.error("Error fetching product page", _t);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[1, 5]]);
      }));
      function handleComponentUpdate(_x) {
        return _handleComponentUpdate.apply(this, arguments);
      }
      return handleComponentUpdate;
    }()
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ },

/***/ "./resources/scripts/utils/CookieMethods.ts"
/*!**************************************************!*\
  !*** ./resources/scripts/utils/CookieMethods.ts ***!
  \**************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   deleteCookie: () => (/* binding */ deleteCookie),
/* harmony export */   getCookie: () => (/* binding */ getCookie),
/* harmony export */   setCookie: () => (/* binding */ setCookie)
/* harmony export */ });
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function setCookie(name, value, minutes) {
  document.cookie = "".concat(name, "=").concat(value, ";max-age=").concat(minutes * 60, ";path=/");
}
function getCookie(name) {
  var cookies = document.cookie.split(';');
  var foundCookie = cookies.find(function (cookie) {
    var _cookie$split = cookie.split('='),
      _cookie$split2 = _slicedToArray(_cookie$split, 1),
      cookieName = _cookie$split2[0];
    return cookieName.trim() === name;
  });
  return foundCookie === null || foundCookie === void 0 ? void 0 : foundCookie.split('=')[1];
}
function deleteCookie(name) {
  document.cookie = "".concat(name, "=;max-age=0;path=/");
}

/***/ },

/***/ "./resources/styles/app.css"
/*!**********************************!*\
  !*** ./resources/styles/app.css ***!
  \**********************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		if (!(moduleId in __webpack_modules__)) {
/******/ 			delete __webpack_module_cache__[moduleId];
/******/ 			var e = new Error("Cannot find module '" + moduleId + "'");
/******/ 			e.code = 'MODULE_NOT_FOUND';
/******/ 			throw e;
/******/ 		}
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/shopify-theme/assets/edition": 0,
/******/ 			"shopify-theme/assets/edition": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkpitayadk"] = self["webpackChunkpitayadk"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["shopify-theme/assets/edition"], () => (__webpack_require__("./resources/app.ts")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["shopify-theme/assets/edition"], () => (__webpack_require__("./resources/styles/app.css")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;